var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12539 -18623)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-12539 18623)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12533.736 18626.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2683.767-700.278c-3.592,0-7.185-.033-10.777.017a1.836,1.836,0,0,1-1.978-2.017,10.092,10.092,0,0,1,7.62-9.469,11.926,11.926,0,0,1,2.612-.306c2.049-.024,4.1-.027,6.146.074a9.232,9.232,0,0,1,5.957,2.627,9.786,9.786,0,0,1,3.041,5.554,10.756,10.756,0,0,1,.166,1.716,1.672,1.672,0,0,1-1.8,1.8Q2689.257-700.273,2683.767-700.278Zm-10.01-2.7h20.1c-.09-.4-.151-.746-.246-1.083a7.228,7.228,0,0,0-6.486-5.3c-2.115-.048-4.232-.029-6.348-.006a6.864,6.864,0,0,0-5.258,2.464A7.066,7.066,0,0,0,2673.757-702.98Z",
    transform: "translate(-2671.01 729.447)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2729.927-860.374a7.144,7.144,0,0,1-7.239-7.142,7.1,7.1,0,0,1,7.263-7.382,7.12,7.12,0,0,1,7.255,6.921A7.171,7.171,0,0,1,2729.927-860.374Zm0-2.658a4.534,4.534,0,0,0,4.647-4.609,4.532,4.532,0,0,0-4.625-4.581,4.507,4.507,0,0,0-4.614,4.584A4.5,4.5,0,0,0,2729.928-863.032Z",
    transform: "translate(-2717.172 874.898)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.67b40ece.svg";
export { ForwardRef as ReactComponent };